import subscriptionDelete from "./graphql/subscription_delete.graphql";
import subscriptionCreate from "./graphql/subscription_create.graphql";
import subscriptionUpdate from "./graphql/subscription_update.graphql";
import subscriptionQuery from "./graphql/subscription_query.graphql";

import { runQuery } from "@/api/query";

export const querySubscription = async (ownerId) => {
  const result = await runQuery(subscriptionQuery, { filter: {ownerId}});
  const subscriptionData = result.subscription.node;

  if (!subscriptionData || !subscriptionData.updatedBy) {
    return null;
  }

  return {
    ownerId: subscriptionData.ownerId,
    emailList: subscriptionData.emailList || [],
    excludedDevices: subscriptionData.excludedDevices  || [],
    subscriptionStatus: subscriptionData.subscriptionStatus || 'INACTIVE'
  };
};

export const createSubscription = async (data) => {
  return await runQuery(subscriptionCreate, {
    ...data,
  });
};

export const updateSubscription = async (data) => {
  return await runQuery(subscriptionUpdate, {
    ...data,
  });
};

export const deleteSubscription = async (ownerId) => {
  return await runQuery(subscriptionDelete, { ownerId: ownerId });
};
